<template>
  <v-expansion-panels flat v-model="panelIndex">
    <v-expansion-panel flat>
      <v-expansion-panel-title>
        <div style="display: flex; align-items: center; width: 100%;">
          <v-chip v-if="this.meetings?.length > 0" size="x-small" class="mr-2">{{ this.meetings?.length }}</v-chip>
          <span>📂 {{ title }}</span>
          <div style="flex: 1 1 auto;"></div>
          <!-- Botón + alineado a la derecha -->
          <v-tooltip text="Nueva reunión" location="top">
            <template #activator="{ props }">
              <v-btn icon small variant="text" v-bind="props" @click.stop="newMeetingDialog = !newMeetingDialog">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </div>

        <template #actions></template>
      </v-expansion-panel-title>

      <!-- Body -->
      <v-expansion-panel-text>
        <div class="d-flex justify-center my-2" v-if="loading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-list v-else>
          <VTooltip v-for="(meet, index) in meetings" :key="meet._id" right>
            <template #activator="{ props }">
              <v-list-item @mouseenter="meet.showDeleteButton = true" @mouseleave="meet.showDeleteButton = false"
                v-bind="props" :class="{ 'glow': meet.state === 'in-meeting' }" @click="goToMeeting(meet._id)">
                <span>🔊 {{ (meetings.length - index - 1).toString().padStart(2, '0') }}.</span>
                <span>Reunión</span>
                <v-btn v-if="meet.showDeleteButton" icon variant="text" color="red"
                  @click.stop="deleteMeeting(meet._id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>

                <!-- Todo: arreglar porque tira error de eslint -->
                <!-- <v-avatar v-if="meet._id === $route.params.meetingId" v-for="(user, idx) in connectedUsers.slice(0, 5)"
                  :key="idx" size="24">
                  <v-img :src="user.avatar ?? $store.state.defaultAvatar" alt="avatar" />
                  </v-avatar> -->
              </v-list-item>
            </template>
            <span>{{ meet.name }}</span>
          </VTooltip>
        </v-list>
      </v-expansion-panel-text>

      <!-- Ventana flotante -->
      <NewMeetingComponent v-if="newMeetingDialog" v-model:dialog="newMeetingDialog" :projectId="projectId" />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import api from '@/api.js';
import NewMeetingComponent from '@/components/project/NewMeetingComponent.vue';

export default {
  name: 'MeetingFolder',
  components: {
    NewMeetingComponent
  },
  props: {
    title: {
      type: String,
      required: true
    },
    projectId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      panelIndex: false,
      isOpen: false,
      newMeetingDialog: false,
      meetings: [],
      loading: false,
    }
  },
  computed: {
    connectedUsers() {
      return this.$store.state.conected_users;
    }
  },
  watch: {
    panelIndex(newVal) {
      this.isOpen = newVal === 0;
      if (this.isOpen && this.meetings.length === 0) {
        this.loadMeetings();
      }
    }
  },
  methods: {
    async loadMeetings() {
      if (!this.projectId) return;
      try {
        this.loading = true;
        const response = await api.get(`/api/meeting/project/${this.projectId}`);
        const meetings = response.data.reverse();
        this.meetings = meetings;
        this.$store.commit('set', { att: 'meetings', value: meetings });
      } catch (error) {
        console.error("Error cargando reuniones:", error);
      } finally {
        this.loading = false;
      }
    },
    async deleteMeeting(meetingId) {
      try {
        await api.delete(`/api/meeting/${meetingId}`);
        this.$socket.emit('event_delete_meeting', { room: this.projectId, meetingId });
        window.location.reload();
      } catch (error) {
        console.error('Error al eliminar la reunión:', error);
      }
    },
    goToMeeting(meetingId) {
      const projectId = this.$route.params.projectId;
      window.location.href = `/p/${projectId}/meeting/${meetingId}`;
    }
  },
  created() {
    // No cargar automáticamente al iniciar, ahora se carga cuando se abre el panel
    // Si está abierto por defecto (panelIndex = true), cargar las reuniones
    if (this.isOpen) {
      this.loadMeetings();
    }

    this.$socket.on('new_meeting', (meeting) => {
      console.log('[socket] new_meeting', meeting);
      if(meeting.project[0] === this.projectId){
        this.meetings.unshift(meeting);
      }
    });

    this.$socket.on('event_delete_meeting', payload => {
      const { meetingId } = payload;
      this.meetings = this.meetings.filter(meeting => meeting._id !== meetingId);
      this.$store.commit('setSnackbar', {
        message: 'Reunión eliminada',
        color: 'red',
        timeout: 3000,
      });
    })
  }
}
</script>

<style scoped>
@keyframes pulseGlow {
  0% {
    box-shadow: 0 0 0px 0 rgba(0, 164, 153, 0.7);
  }

  50% {
    box-shadow: 0 0 12px 6px rgba(0, 164, 153, 0.5);
  }

  100% {
    box-shadow: 0 0 0px 0 rgba(0, 164, 153, 0.7);
  }
}

.glow {
  animation: pulseGlow 2s infinite;
}
</style>